import React from 'react'
import './WinterLoading.css'

// Génère les flocons de neige avec des tailles variées
const generateSnowflakes = () => {
  const sizes = ['lg', 'md', 'sm']
  return Array.from({ length: 12 }, (_, i) => {
    const size = sizes[i % 3]
    return (
      <div
        key={i}
        className={`winter-loading__snowflake winter-loading__snowflake--${size}`}
      />
    )
  })
}

const WinterLoading = () => (
  <div className="winter-loading">
    {/* Flocons de neige */}
    <div className="winter-loading__snowflakes">
      {generateSnowflakes()}
    </div>

    {/* Icône de chargement */}
    <div className="winter-loading__icon">❄</div>

    {/* Sol enneigé */}
    <div className="winter-loading__ground" />
  </div>
)

export default WinterLoading